import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUserProfileState } from './user-profile.reducer';

const selectFeature = createFeatureSelector<IUserProfileState>('userProfile');

export const getDeleteUserActionState = createSelector(
  selectFeature,
  state => state.deleteUserActionState
);

export const getChangePasswordActionState = createSelector(
  selectFeature,
  state => state.changePasswordActionState
);

export const getChangeEmailActionState = createSelector(
  selectFeature,
  state => state.changeEmailActionState
);

export const getLegalTexts = createSelector(selectFeature, state => state.legalTexts);

export const getLegalTextsActionState = createSelector(
  selectFeature,
  state => state.legalTextsActionState
);

export const getPersonalData = createSelector(selectFeature, state => state.personalData);

export const getPersonalDataActionState = createSelector(
  selectFeature,
  state => state.personalDataActionState
);

export const getConsent = createSelector(selectFeature, state => state.consent);
export const getIsConsentLoading = createSelector(
  selectFeature,
  state => state.consentActionState?.pending
);

export const getConsentSetActionState = createSelector(
  selectFeature,
  state => state.consentSetActionsState
);

export const getIsConsentSetLoading = createSelector(
  selectFeature,
  state => state.consentSetActionsState?.pending
);

export const getHasMissingMandatoryConsent = createSelector(
  selectFeature,
  state => state.hasMissingMandatoryConsent
);

export const getMissingConsents = createSelector(selectFeature, state => state.missingConsents);

export const getMissingConsentsActionState = createSelector(
  selectFeature,
  state => state.missingConsentsActionState
);

export const getSetConsentV2ActionState = createSelector(
  selectFeature,
  state => state.consentSetActionsState
);
